import React, { useRef } from "react";
import { ThemeProvider } from "styled-components";
import defaultTheme from "../../themes/defaultTheme";
export const ThemeWrapper = (props) => {
    const themeLoadInitiated = useRef(false);
    if (!themeLoadInitiated.current) {
        themeLoadInitiated.current = true;
    }
    return (React.createElement(ThemeProvider, { theme: defaultTheme }, props.children));
};
